import * as Yup from 'yup';

export const companySchema = Yup.object({
  companyName: Yup.string().required('Company name is required'),

  companyIndustry: Yup.string().optional(),

  companyWebsite: Yup.string().url('Enter a valid website URL').nullable().optional(),

  baseCurrency: Yup.string().required('Currency is required'),

  placeOfSupply: Yup.string().required('Place of supply is required'),

  companyAddress: Yup.object({
    addressLine1: Yup.string().optional(),
    addressLine2: Yup.string().optional(),
    city: Yup.string().optional(),
    state: Yup.string().optional(),
    pinCode: Yup.string().optional(),
    phone: Yup.string()
      .matches(
        /^(\+91|91)?[6-9]\d{9}$/,
        'Enter a valid phone number (with or without country code)'
      )
      .optional(),
  }),
  gstTreatment: Yup.object().shape({
    gstNumber: Yup.string().when('gstType', {
      is: 'registered',
      then: (schema) => schema.required('GST number is required'),
    }),
  }),
});
